import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Optional, Self, ViewChild } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BaseGenericInputComponent } from '../base-generic-input/base-generic-input.component';

@Component({
    selector: 'mat-generic-mask-input',
    templateUrl: './generic-mask-input.component.html',
    styleUrls: [ '../base-generic-input/base-generic-input.component.scss', './generic-mask-input.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: GenericMaskInputComponent,
        },
    ],
})
export class GenericMaskInputComponent extends BaseGenericInputComponent<string>  {

    @ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger })
    public inputAutoComplete: MatAutocompleteTrigger;

    constructor(
        @Optional()
        @Self()
        protected myNgControl: NgControl,
        protected myChangeDetectorRef: ChangeDetectorRef,
    ) {
        super(myChangeDetectorRef);

        if (this.myNgControl) {
            this.myNgControl.valueAccessor = this;
        }
    }
    public openAutocomplete(): void {
        if (this.inputAutoComplete) {
            setTimeout(() => this.inputAutoComplete.openPanel(), 100);
        }
    }
}
